import { importSync } from '@embroider/macros';
export { default, svgJar } from 'ember-svg-jar/helpers/svg-jar';
